import Div from '@ui/layout/Div'
import { object, string } from 'prop-types'
import Link from '@ui/elements/Link'
import Icon from '@ui/elements/Icon'

const DropDown = ({ dropConfig, mainButtonCssClass, cssClass }) => {
  const getDropDownMenu = () => {
    return dropConfig.menu.map(target => <Link
      link={target.link}
      title={target.title}
      text={target.text}
      cssClass='dropdown-item'
      key={target.title}
      otherProps={target.otherProps}
    />)
  }
  return (
    <Div cssClass={`dropdown is-hoverable ${cssClass}`}>
      <Div cssClass="dropdown-trigger">
        <button className={`button ${mainButtonCssClass}`} aria-haspopup="true" aria-controls="dropdown-menu">
          <span>{dropConfig.title}</span>
          <Icon spanClass='is-small' icon='icon-keyboard_arrow_down' />
        </button>
      </Div>
      <Div cssClass="dropdown-menu" id="dropdown-menu" role="menu">
        <Div cssClass="dropdown-content">
          {getDropDownMenu()}
        </Div>
      </Div>
    </Div>
  )
}

DropDown.propTypes = {
  dropConfig: object,
  cssClass: string,
  mainButtonCssClass: string
}

export default DropDown
